import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import Popover from 'material-ui/Popover';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import { Link } from 'react-router-dom';
import debounce from 'lodash/debounce';
import ImageLoader from '../Shared/ImageLoader/ImageLoader';
import { getImageLink } from '../../helpers/imageHelper';
import {imageSizes, route} from '../../config/constants';
import {setThemeMode, getEffectiveTheme} from '../../helpers/themeHelper';
import './styles.css';
import theme from './theme';
import SlatesSearch from './../../containers/SlatesSearch';
import tryMe from '../../helpers/tryMe';
import { zendeskOffsets } from '../../helpers/setupZendesk';
import {isLoggedOut} from "../../helpers/accountHelper";
import RaisedButton from "material-ui/RaisedButton";
import { withTranslation } from 'react-i18next';
import {withRouter} from 'react-router-dom';
import {history} from "../../store/createStore";
import {connect} from "react-redux";

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenProfile: false,
      isOpenDialog: false,
      isOpenSearch: false,
      isOpenTheme: false,
    };
    this.userNameRef = React.createRef();
    this.themeBtnRef = React.createRef();
  }

  handleProfileDropdown = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      isOpenProfile: true,
      anchorEl: e.currentTarget,
    });
  };

  handleDropdownClose = () => {
    this.setState({
      isOpenProfile: false,
    });
  };

  handleThemeDropdown = (e) => {
    if (e) {
      e.preventDefault();
    }
    var rect = this.themeBtnRef.current
      ? this.themeBtnRef.current.getBoundingClientRect()
      : null;
    this.setState({
      isOpenTheme: true,
      themeDropdownPos: rect ? { top: rect.bottom + 8, right: window.innerWidth - rect.right } : null,
    });
  };

  handleThemeDropdownClose = () => {
    this.setState({
      isOpenTheme: false,
    });
  };

  getThemeIcon = () => {
    return getEffectiveTheme(this.props.themeMode) === 'dark' ? 'dark_mode' : 'light_mode';
  };

  handleSyncToggle = () => {
    var currentUser = this.props.currentUser;
    var userUuid = currentUser && currentUser.uuid;
    if (this.props.themeMode === 'system') {
      setThemeMode(getEffectiveTheme('system'), userUuid);
    } else {
      setThemeMode('system', userUuid);
    }
  };

  handleSearchToggle = () => {
    const isOpenSearch = !this.state.isOpenSearch;
    this.setState({ isOpenSearch }, () => this.updateZendeskWidgetPosition());
  };

  updateZendeskWidgetPosition = (nameLabel = this.userNameRef.current) => {
    const launcher = document.querySelector('iframe.zEWidget-launcher');
    if (launcher) {
      const nameWidth = nameLabel
        ? zendeskOffsets.HIDE + nameLabel.getBoundingClientRect().width
        : 0;
      const newHorizontalOffset = `${zendeskOffsets.RIGHT + nameWidth}px`;
      if (launcher.style.marginRight !== newHorizontalOffset) {
        launcher.style.marginRight = newHorizontalOffset;
      }
      const newVerticalOffset = `${
        this.state.isOpenSearch || this.props.isOpenSidebarMobile
          ? -zendeskOffsets.HIDE
          : zendeskOffsets.TOP
      }px`;
      if (launcher.style.marginTop !== newVerticalOffset) {
        launcher.style.marginTop = newVerticalOffset;
      }
    } else {
      setTimeout(this.updateZendeskWidgetPosition, 100);
    }
  };

  onWindowResize = debounce(() => this.updateZendeskWidgetPosition(), 50);

  componentDidMount() {
    this.updateZendeskWidgetPosition();
    window.addEventListener('resize', this.onWindowResize);
  }

  componentWillUnmount() {
    this.updateZendeskWidgetPosition(null);
    window.removeEventListener('resize', this.onWindowResize);
  }

  componentDidUpdate(prevProps) {
    if (
      tryMe(prevProps.currentUser).name !==
        tryMe(this.props.currentUser).name ||
      prevProps.isOpenSidebarMobile !== this.props.isOpenSidebarMobile
    ) {
      this.updateZendeskWidgetPosition();
    }
  }

  render() {
    const { currentUser, imagesLinks, handleSidebarToggle, accountsList, currentAccountUuid, currentAccount } = this.props;
    const { isOpenSearch } = this.state;
    const loggedOut = isLoggedOut(currentUser);
    let link;

    if (currentUser) {
      link = getImageLink(
        currentUser.imageUUID,
        imagesLinks,
        imageSizes.USER_TOPBAR,
      );
    }

    // Get account image for public view
    let accountLink;
    let accountFirstLetter = '';
    if (currentAccount) {
      accountLink = getImageLink(
        currentAccount.imageUUID,
        imagesLinks,
        imageSizes.ACCOUNT_SIDEBAR,
      );
      accountFirstLetter = currentAccount.name ? currentAccount.name[0].toUpperCase() : '';
    }

    let shouldShowSearchOfSlates = false;

    accountsList && accountsList.forEach(account => {
      if(currentAccountUuid && (currentAccountUuid === (account && account.uuid))) {
        shouldShowSearchOfSlates = true;
      }
    })

    return (
      <div className="topbar" style={theme.appHeader}>
        <div className="topbar-inner">
          {!loggedOut && (
            <div className="inline device-screen-only">
              <IconButton
                iconClassName="material-icons"
                onClick={handleSidebarToggle}
                className="topbar-toggle"
              >
                menu
              </IconButton>
            </div>
          )}

          {
            !loggedOut ?
              <>
                {
                  shouldShowSearchOfSlates &&
                    <>
                      <div className="inline device-screen-only">
                        <IconButton
                          iconClassName="material-icons"
                          onClick={this.handleSearchToggle}
                          className="topbar-toggle"
                          iconStyle={isOpenSearch ? theme.searchIcon : {}}
                        >
                          search
                        </IconButton>
                      </div>
                      <div className={`topbar-search ${isOpenSearch ? 'toggled' : ''}`}>
                        <SlatesSearch />
                      </div>
                    </>
                }
                <div className="profile-wrapper">
                  <div
                    className={classnames({
                      'topbar-user-profile': true,
                      open: this.state.isOpenProfile,
                    })}
                    onClick={this.handleProfileDropdown}
                  >
                    <div ref={this.userNameRef} className="topbar-user-name">
                      {currentUser.name}
                    </div>

                    <div
                      className="avatar-default"
                      style={link ? {} : theme.avatarDefault}
                    >
                      {link && (
                        <ImageLoader
                          url={link}
                          spinnerWidth={imageSizes.USER_TOPBAR.width / 2}
                          containerStyle={theme.imageLoaderBorder}
                          imageStyle={theme.imageLoaderBorder}
                          preloaderStyle={theme.imageLoaderBorder}
                          isBorder
                        />
                      )}
                      {!link && currentUser.profileLetter}
                    </div>

                    <i
                      className={classnames('material-symbols-outlined', 'topbar-chevron', {
                        'topbar-chevron-open': this.state.isOpenProfile,
                      })}
                      style={theme.appHeaderUserChevron}
                    >expand_more</i>
                    <Popover
                      className="topbar-popover-animated"
                      open={this.state.isOpenProfile}
                      anchorEl={this.state.anchorEl}
                      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                      targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                      onRequestClose={this.handleDropdownClose}
                      zDepth={0}
                      style={{
                        marginTop: 8,
                        background: 'transparent',
                        boxShadow: 'none',
                        overflow: 'visible',
                        borderRadius: 10,
                      }}
                    >
                      <div className="popover topbar-popover">
                      <Link
                        to="/profile"
                        className="popover-item"
                        onClick={this.handleDropdownClose}
                      >
                        {this.props.t('common:profileSettings')}
                      </Link>
                      <div className="popover-item" onClick={this.handleLogout}>
                        {this.props.t('common:logOut')}
                      </div>
                      </div>
                    </Popover>
                  </div>
                </div>
                <div className="topbar-theme-toggle">
                  <button
                    ref={this.themeBtnRef}
                    className="topbar-theme-btn"
                    onClick={this.handleThemeDropdown}
                    title="Theme"
                    aria-label="Toggle theme"
                    aria-haspopup="true"
                    aria-expanded={this.state.isOpenTheme}
                  >
                    <span className="material-symbols-outlined">{this.getThemeIcon()}</span>
                  </button>
                  {this.state.isOpenTheme && ReactDOM.createPortal(
                    <>
                      <div className="theme-popover-backdrop" onClick={this.handleThemeDropdownClose} />
                      <div
                        className="popover theme-popover"
                        role="menu"
                        style={this.state.themeDropdownPos ? { top: this.state.themeDropdownPos.top, right: this.state.themeDropdownPos.right } : {}}
                      >
                        {[
                          { mode: 'light', icon: 'light_mode', label: 'Light' },
                          { mode: 'dark', icon: 'dark_mode', label: 'Dark' },
                        ].map(function(opt) {
                          var effectiveTheme = getEffectiveTheme(this.props.themeMode);
                          var isActive = effectiveTheme === opt.mode;
                          var self = this;
                          return (
                            <div
                              key={opt.mode}
                              className={classnames('theme-popover-option', { active: isActive })}
                              role="menuitem"
                              aria-current={isActive ? 'true' : undefined}
                              onClick={function() {
                                setThemeMode(opt.mode, currentUser && currentUser.uuid);
                              }}
                            >
                              <span className="material-symbols-outlined">{opt.icon}</span>
                              <span className="theme-popover-label">{opt.label}</span>
                              <span className={classnames('theme-popover-radio', { active: isActive })} />
                            </div>
                          );
                        }.bind(this))}
                        <div className="theme-popover-separator" />
                        <label className="theme-popover-sync" onClick={function(e) { e.stopPropagation(); }}>
                          <input
                            type="checkbox"
                            className="theme-popover-sync-input"
                            checked={this.props.themeMode === 'system'}
                            onChange={this.handleSyncToggle}
                          />
                          <span className="theme-popover-sync-box">
                            <svg className="theme-popover-sync-icon" viewBox="0 0 12 10" fill="none">
                              <path d="M1 5L4.5 8.5L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>
                          <span className="theme-popover-sync-label">Match Device</span>
                        </label>
                      </div>
                    </>,
                    document.body
                  )}
                </div>
              </>
              :
              <div className="topbar-public-layout">
                {/* Account Logo and Name - Left side */}
                <div className="topbar-account-info">
                  <div className="topbar-account-logo">
                    {accountLink ? (
                      <ImageLoader
                        url={accountLink}
                        spinnerWidth={16}
                        containerStyle={{ borderRadius: 6 }}
                        imageStyle={{ borderRadius: 6, width: 32, height: 32 }}
                      />
                    ) : (
                      accountFirstLetter
                    )}
                  </div>
                  <div className="topbar-account-name">
                    {currentAccount && currentAccount.name}
                  </div>
                </div>

                {/* Public Message - Center */}
                <div className="topbar-public-message">
                  This is a public version of this view. For full access, contact the administrator or owner of this Stack.
                </div>

                {/* Actions - Right side */}
                <div className="topbar-public-actions">
                  <RaisedButton
                    onClick={this.handleLogin}
                    className="btn topbar-login-btn"
                    label={this.props.t('btn:logIn')}
                    primary={true}
                    style={theme.loginButtonStyle}
                    buttonStyle={theme.loginButton}
                  />
                </div>
              </div>
          }
        </div>
      </div>
    );
  }

  handleLogout = () => {
    this.props.logout();
  };

  handleLogin = () => {
    const {pathname, search} = this.props.location;
    const currentUrl = pathname + (search || '');
    history.push({
      pathname: route.START,
      search: `?returnTo=${encodeURIComponent(currentUrl)}`,
    });
  };
}

export default withTranslation()(withRouter(Topbar));
